// extracted by mini-css-extract-plugin
export var label = "_b1-1";
export var reminder = "_b1-0";